export default {
  title: 'Atributos alimentares',
};
